import _ from 'underscore';
import * as PIXI from 'pixi.js-legacy';

window.PIXI = PIXI;
window._ = _;
require('./pixi-component.js');

export function GetPixiComponent() {
  return window.PixiComponent;
}
